import policyApi from "../../../../api/policy";

const getInitialEditPageData = ({ dispatch, commit, getters }) => {
  if (!getters.policyId || !getters.customerId) return;

  commit("LOADING_EDIT_PAGE", true);

  if (getters.genericGetters("isSinglePolicy")) {
    dispatch("getInitialEditSinglePolicyPageData");
  } else {
    dispatch("getInitialEditPolicyPageData");
  }
};
const getInitialEditPolicyPageData = ({ commit, getters, dispatch }) => {
  policyApi.editPolicy(
    getters.policyId,
    getters.customerId,
    getters.packageId,
  ).then((response) => {
    commit("SET_INITIAL_EDIT_PAGE_DATA", response.data);
    commit("$_generic_insurance/SET_FORM", response.data?.form, { root: true });
    commit("$_generic_insurance/SET_VIEWS", response.data?.renderableInputs, { root: true });
    dispatch("$_generic_insurance/getViewOptions", null, { root: true });
    commit("LOADING_EDIT_PAGE", false);
  });
};

const getInitialEditSinglePolicyPageData = ({ getters, commit, dispatch }) => {
  policyApi.editSinglePolicy(getters.policyId, getters.customerId).then((response) => {
    commit("SET_INITIAL_EDIT_PAGE_DATA", response.data);
    commit("$_generic_insurance/SET_FORM", response.data?.form, { root: true });
    commit("$_generic_insurance/SET_VIEWS", response.data?.renderableInputs, { root: true });
    dispatch("$_generic_insurance/getViewOptions", null, { root: true });
    commit("LOADING_EDIT_PAGE", false);
  });
};

const updatePolicy = ({ state, commit }, formData) => {
  commit("SET_LOADING_RESPONSE", true);
  policyApi.updatePolicy(formData, state.policyId, state.customerId)
    .then(() => {
      commit("SET_SAVED_AT");
    }).finally(() => {
      commit("SET_LOADING_RESPONSE", false);
    });
};

export default {
  getInitialEditPageData,
  getInitialEditPolicyPageData,
  getInitialEditSinglePolicyPageData,
  updatePolicy,
};
